import { SVGProps } from "react";

const Padlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={157}
    height={157}
    viewBox="0 0 157 157"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.6811 6.99414C57.5166 6.99414 40.3594 24.1514 40.3594 45.3159V64.4768H117.003V45.3159C117.003 24.1514 99.8457 6.99414 78.6811 6.99414ZM78.6849 22.4702C66.0676 22.4702 55.8393 32.6986 55.8393 45.3159V64.4768H101.531V45.3159C101.531 32.6986 91.3022 22.4702 78.6849 22.4702Z"
      fill="#0054DB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.5255 71.1094C30.0868 71.1094 24.8672 76.329 24.8672 82.7677V125.91C24.8672 138.788 35.3064 149.227 48.1838 149.227H109.146C122.024 149.227 132.463 138.788 132.463 125.91V82.7677C132.463 76.329 127.243 71.1094 120.805 71.1094H36.5255ZM91.1897 102.429C91.1897 107.562 88.0093 111.953 83.5115 113.737L86.7626 129.697H70.9181L73.9233 113.468C69.7587 111.538 66.8701 107.321 66.8701 102.429C66.8701 95.7138 72.3142 90.2697 79.0299 90.2697C85.7456 90.2697 91.1897 95.7138 91.1897 102.429Z"
      fill="#003890"
    />
  </svg>
);
export default Padlock;
